module.exports = __webpack_public_path__ + "static/img/3.0586937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Todo-riesgo-empresarial/3.png
// module id = CEkF
// module chunks = 0